import DialogInfo from '~/components/dialog/info/DialogInfo.vue';
import { dataImportCommon } from '~/lib/data/importCommon';
export const useAssessmentDelete = (uuid: string) => {
  const dialog = useDialogStore();

  const { $db } = useNuxtApp();

  const { importAssessments } = dataImportCommon($db, useApiFetch);

  const sendDeleteRequest = async () => {
    const { error } = await useApiFetch(
      `${URI.AssessmentsDeleteByUuid}/${uuid}`,
      {
        method: 'DELETE',
      }
    );
    if (error) {
      throw error;
    }
  };

  const openDeleteDialog = () => {
    dialog.open(DialogInfo, {
      level: DialogLevel.Settings,
      iconHeader: 'assessment',
      title: 'Éval',
      label: 'Veux tu vraiment supprimer cette éval ?',
      cancel: true,
      onCancel: () => dialog.close(),
      onConfirm: async () => {
        dialog.close();
        try {
          await sendDeleteRequest();
          await importAssessments();
          navigateTo(`/${Sections.ChildForYou}`, { replace: true });
        } catch (e) {
          dialog.open(DialogInfo, {
            level: DialogLevel.Settings,
            title: 'Éval',
            label: e.response?._data?.summary || "une erreur s'est produite",
            onConfirm: () => dialog.close(),
          });
        }
      },
    });
  };
  return {
    openDeleteDialog,
  };
};
